import Button from "shared/UI/Buttons/Button";
import "./Form.css";

type FormCancelButtonProps = {
  text: string;
  onClick: VoidFunction;
};

export const FormCancelButton = (props: FormCancelButtonProps) => {
  return (
    <Button
      className="max-w-[200px]"
      aria-label={props.text}
      variant="secondary"
      text={props.text}
      onClick={props.onClick}
    />
  );
};
